<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card class="pa-4" flat>
        <custom-tabs
          v-model="tabs"
          :tab-props="tabProps"
          :tabItems="tabHeader"
          :window-items="tabHeader"
          :window-props="windowProps"
          grow
        >
          <template v-slot:item>
            <v-card-text class="px-md-16 pt-10">
              <router-view />
            </v-card-text>
          </template>
          <template v-slot:helpinfo="{ tab }">
            <help-info
              v-if="tab && tab.value && tab.text && tab.id"
              :element-name="`${serviceName}-${componentName}-${tab.value}-${tab.id}`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="tab.text"
            />
          </template>
        </custom-tabs>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
export default {
  name: "category",

  data() {
    return {
      serviceName: "Qrland",
      componentName: "category",
      helpData: [],
      tabs: null,
      tabProps: {
        ripple: false,
        to: "/qr/cate/:value",
      },
      windowProps: {
        value: "/qr/cate/:value",
      },
    };
  },
  computed: {
    tabHeader() {
      return [
        {
          text: this.$t("sharing"),
          icon: "share-variant-outline",
          value: "share",
          id: 1,
        },
        {
          text: this.$t("business_shop"),
          icon: "store-marker-outline",
          value: "business-shop",
          id: 2,
        },
        {
          text: this.$t("corporate_organizational"),
          icon: "account-tie-woman",
          value: "co-organ",
          id: 3,
        },
        {
          text: this.$t("social_network"),
          icon: "account-group-outline",
          value: "socialnetwork",
          id: 4,
        },
        {
          text: this.$t("customer_contact"),
          icon: "face-agent",
          value: "contact",
          id: 5,
        },
        {
          text: this.$t("information"),
          icon: "bulletin-board",
          value: "notices",
          id: 6,
        },
        {
          text: this.$t("miscellaneous"),
          icon: "format-list-bulleted-type",
          value: "others",
          id: 7,
        },
        
        
      ];
    },
  },
  methods: {
    changeTab(e) {
      // this.goto(e.substring(1))
    },
  },
};
</script>

<style scoped>
.v-card >>> .cat-holder > *,
.v-card >>> .cat-holder .main-bg,
.v-card >>> .cat-holder .cat-content:before {
  box-shadow: -3px 3px 2px 0 rgba(0, 0, 0, 0.2);
}

.v-card >>> .cat-holder .main-bg {
  top: 0;
  right: 28px;
  width: 75%;
}

.v-card >>> .cat-holder .main-bg,
.v-card >>> .cat-content:before {
  content: "";
  position: absolute;
  transform: skewX(-13deg);
  height: 100%;
  z-index: 0;
}

.v-card >>> .cat-content {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 12px;
  width: 75%;
}

.v-card >>> .cat-content:before {
  top: -12px;
  right: 20px;
  width: 100%;
  background: linear-gradient(
    to bottom left,
    #bdbec0,
    #f0f0f0,
    #f0f0f0,
    #bdbec0
  );
  border: 1px solid white;
}

.v-card >>> .cat-content > * {
  position: relative;
  z-index: 1;
}
</style>
